import { useGeolocation, getGeolocation, GeolocationError } from '../util/geolocation'
import TomSelect from 'tom-select/dist/js/tom-select.base.js'
import simpleAlert from 'frontend/unpoly/javascripts/util/simple_alert'

up.compiler('[data-career-search-place-select]', (element, { path }: { path: string }) => {
  const tomselect = new TomSelect(element, {
    valueField: 'place_id',
    labelField: 'text',
    searchField: 'text',
    sortField: [{ field: '$order' }, { field: '$score' }],
    hidePlaceholder: false,
    closeAfterSelect: true,
    create: false,
    persist: false,
    async shouldLoad() {
      return true
    },
    async load(query: string, callback: (response: object) => void) {
      if (query === '') {
        this.clearOptions()
        callback([])
      } else {
        const url = new URL(path, window.location.origin)
        const searchParams = new URLSearchParams({ term: query })
        url.search = searchParams.toString()

        const response = await (await fetch(url)).json()
        this.clearOptions()
        callback(response)
      }
    },
    onType(value: string) {
      if (value.length === 0) {
        this.clearOptions()
      }
    },
    render: {
      no_results({ input }: { input: string }) {
        if (input === '') {
          if (useGeolocation()) {
            return '<span></span>'
          } else {
            return '<div class="no-results">Ort oder PLZ eingeben.</div>'
          }
        } else {
          return '<div class="no-results">Keine Ergebnisse.</div>'
        }
      },
      dropdown() {
        if (useGeolocation()) {
          return '<div><a geolocate-button class="career-search-form--geolocate-button">aktuellen Standort verwenden</a></div>'
        } else {
          return '<div></div>'
        }
      },
    },
  })

  function showError(message: string) {
    const body = up.element.createFromHTML(`
      <div>
        <p message>
        </p>
        <p class="fw-bold">
          Bitte gib deinen Ort oder die PLZ manuell ein.
        </p>
      </div>
    `)
    body.querySelector('[message]')!.textContent = message
    simpleAlert({
      body,
    })
  }

  const clearButton = up.element.createFromHTML('<div class="ts-clear-button"></div>')
  tomselect.control.appendChild(clearButton)

  clearButton.addEventListener('click', (event) => {
    tomselect.clear(true)
    tomselect.close()
    event.stopPropagation()
  })

  up.on(tomselect.dropdown, 'click', '[geolocate-button]', async (event) => {
    event.preventDefault()
    tomselect.close()
    try {
      const { latitude, longitude } = await getGeolocation({
        mayAskForPermission: true,
        timeout: 5000,
      })
      const placeId = `${latitude},${longitude}`
      tomselect.addOption({
        place_id: placeId,
        text: 'aktueller Standort',
      })
      tomselect.addItem(placeId)
      tomselect.refreshItems()
    } catch (error) {
      if (error instanceof GeolocationError) {
        showError(error.humanized)
      } else {
        throw error
      }
    }
  })

  return () => {
    tomselect.destroy()
  }
})
